module.exports = __webpack_public_path__ + "img/223-5e9196.png";